import { getSessionData } from '@/auth/authUtil';
import { postFormData, doImport } from '@/util';
import { UploadRawFile, ElMessage, UploadFile, ElMessageBox, ElLoading } from '@qsxy/element-plus-react';
import { Message } from '@qsxy/element-plus-react/dist/Message';
import { useMemo } from 'react';

export const useUpload = () => {
	const accept = useMemo(() => '.pdf,.docx,.xlsx', []);

	const beforeUpload = (rawFile: UploadRawFile) => {
		const name = rawFile.name.toLocaleLowerCase();
		if (!name.endsWith('.pdf') && !name.endsWith('.docx') && !name.endsWith('.xlsx')) {
			ElMessage.warning('仅支持PDF, Word, Excel');
			return false;
		}
		const mb = rawFile.size / 1024 / 1024;
		if (mb > 15) {
			ElMessage.warning('文件大小已超出15MB');
			return false;
		}
		const { usage } = getSessionData();
		if (usage?.fileCount <= 0) {
			ElMessageBox.alert(
				`您今日的上传文件次数已用尽，如需更多体验，${usage?.versionType == 0 ? '请前往升级为专业版享受更多次数或等待明天重置次数' : '请等待明天重置次数'}`,
				'温馨提示',
				{
					type: 'warning',
					showCancelButton: false,
				},
			);
			return false;
		}
		if ((usage.fileSize || 0) - rawFile.size < 0) {
			ElMessageBox.alert(
				`剩余知识库容量不足，如需更多体验，${usage?.versionType == 0 ? '请前往升级为专业版享受更多容量或等待明天重置容量' : '请等待明天重置容量'}`,
				'温馨提示',
				{
					type: 'warning',
					showCancelButton: false,
				},
			);
			return false;
		}

		return true;
	};

	const onUpload = (uploadFile: UploadFile, onQuery?: any) => {
		if (!beforeUpload(uploadFile.raw)) {
			return;
		}
		const load = ElLoading.service({ text: '正在上传中...' });
		const { user } = getSessionData();
		const formData = new FormData();
		formData.append('file', uploadFile.raw);
		formData.append('user', user.username);
		formData.append(
			'data',
			JSON.stringify({
				indexing_technique: 'high_quality',
				process_rule: {
					rules: {
						pre_processing_rules: [
							{ id: 'remove_extra_spaces', enabled: true },
							{ id: 'remove_urls_emails', enabled: true },
						],
						segmentation: { separator: '###', max_tokens: 500 },
					},
					mode: 'custom',
				},
			}),
		);
		postFormData(
			`/rest/knowledge/document/createByFile/local/${user.datasetId}`,
			formData,
			({ data }) => {
				formData.append('document_id_local', data.id);
				doImport(
					`/rest/knowledge/document/createByFile/${user.datasetId}`,
					formData,
					() => {
						load.close();
						Message.success('上传成功');
						onQuery?.({ pageNum: 1 });
					},
					() => {
						load.close();
						Message.error('上传失败');
					},
				);
			},
			() => {
				load.close();
				Message.error('上传失败');
			},
		);
	};

	return { accept, beforeUpload, onUpload };
};
